module.exports = __webpack_public_path__ + "img/img-yaoqinghaoyou@2x.4610aa06.png";